export default function BookingColorGenerator(status) {
  if (status === 'COMPLETED') return 'success'
  if (status === 'CANCELED') return 'danger'
  if (status === 'ACCEPTED') return 'yellow'
  if (status === 'CREATED') return 'purple'
  if (status === 'USER_UPCOMING') return 'cyan'
  if (status === 'DRIVER_UPCOMING') return 'secondary'
  if (status === 'DRIVER_SCHEDULED') return 'info'
  if (status === 'PROCESSED') return 'info'
  return 'secondary'
}

export const BOOKINGS_STATES = {
  PROCESSED: 'PROCESSED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  CREATED: 'CREATED',
  ACCEPTED: 'ACCEPTED',
}
